export default __webpack_public_path__ + "static/media/factuur-ipad.af5713ee.png";